import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { NgModule, LOCALE_ID} from '@angular/core';
import localeES from '@angular/common/locales/es';
import { HttpClientModule } from '@angular/common/http';
import { Componente1Module } from '../../componentes/componente1/componente1.module';
import { CompartidoModule } from '../../compartido/compartido.module';
import { ControlaRutaService } from '../servicios/controla-ruta.service';
import { TableModule } from 'primeng/table';
import { MenuService } from '../servicios/menu.service';
import { CalendarModule, MessageService } from 'primeng/primeng';
import { BlockUIModule, KeyFilterModule, ProgressSpinnerModule } from 'primeng/primeng';
import { PLANIFICACION_ROUTES } from './planificacion.route';
import { PlanificacionListarComponent } from './planificacion-listar/planificacion-listar.component';
import { RequerimientoCrearComponent } from './requerimiento-crear/requerimiento-crear.component';
import { RequerimientoListarComponent } from './requerimiento-listar/requerimiento-listar.component';
import {DataViewModule} from 'primeng/dataview';
import {CardModule} from 'primeng/card';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {TabViewModule} from 'primeng/tabview';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ToolbarModule} from 'primeng/toolbar';
import { RequerimientoListarCalendarioComponent } from './requerimiento-listar-calendario/requerimiento-listar-calendario.component';


registerLocaleData(localeES);
@NgModule({
  imports: [
    CommonModule
    , Componente1Module
    , HttpClientModule
    , CompartidoModule
    ,PLANIFICACION_ROUTES
    ,CalendarModule
    ,TableModule
    ,KeyFilterModule
    ,ProgressSpinnerModule
    ,BlockUIModule
    ,TableModule
    ,DataViewModule
    ,CardModule
    ,TooltipModule
    ,InputTextareaModule
    ,TabViewModule
    ,MessageModule
    ,MessagesModule
    ,ToolbarModule


  ],  
  declarations: [
    PlanificacionListarComponent,
    RequerimientoCrearComponent,
    RequerimientoListarComponent,
    RequerimientoListarCalendarioComponent,

  ]
  , providers: [
    
    { provide: LOCALE_ID, useValue: "es-ES" }, //replace "en-US" with your locale
     ControlaRutaService
    ,MenuService, DatePipe

  ]
  , exports: [
  
     PlanificacionListarComponent,
     RequerimientoCrearComponent,
     RequerimientoListarComponent,
     RequerimientoListarCalendarioComponent
    //, MenuService

  ]
})
export class PlanificacionModule { }
